import React, { useState, useEffect } from 'react';
import { Popover, List, ListItem, ListItemText } from '@material-ui/core';
import Popup from '../../Modal/PopUp';
import { makeStyles } from '@material-ui/core/styles';
import EditSpecialty from '../../AddSpecialties/EditSpecialty';
import { connect } from 'react-redux';
import { deleteSpecialty } from '../../../store/actions/UserAction';
import SpecialtyPanel from './SpecialtyPanel';
import { filteredSubSpecialities, filterSubSpecialties, filterExtraSubs } from '../../../utils/SubSpecialties';
import './SpecialtyAdded.scss';

const dropDown = '/img/drop-down-2.svg';
const dropUp = '/img/drop-up-2.svg'

const useStyles = makeStyles({
  popper: {
    width: 120,
    margin: '0 24px 0 0',
    // boxShadow: isMobile ? 'inherit' : '0 2px 5px 0 rgba(0, 0, 0, 0.2)',
    // backgroundColor: isMobile ? 'inherit' : '#f5f5f5',
  },
  list: {
    width: 120,
    backgroundColor: 'white'
  },
  listItem: {
    '&:hover': {
      backgroundColor: '#f5f5f5'
    }
  },
  listItemText: {
    color: '#484848',
    fontSize: 14,
  },
  contentSeeMoreBlock: {
    display: 'flex',
    justifyContent: 'center'
  },
  contentSeeMore: {
    display: 'flex',
    margin: '24px 0 0',
    cursor: 'pointer'
  },
  seeMoreText: {
    color: '#013957',
    fontWeight: 'bold',
    fontSize: 16,
    margin: 'auto 0 4px'
  },
})

function SpecialtyAdded({ 
  uid,
  allSpecialties,
  deleteSpecialty,
  elements,
  fromPublic,
  preview,
  handleSnack,
  alreadyRewarded,
  handleRewarded,
  handleTrophieModalOpen,
  handleEditFlag,
  nElem,
  helper,
  helperTrue,
  helperFalse,
  getValues,
  previewExpanded,
  subSpecialities,
  extraSubSpecialities,
}) {
    const [seeMore, setSeeMore] = useState(false);
    const [flagEdit, setFlagEdit] = useState(0);

    const handleSeeMore = () => {
        setSeeMore(!seeMore)
    }

    const FnEditSpecialty = () => {
        setFlagEdit(1)
        setAnchorEl(null)
    };

    const changeStatus = (isActive) => {
        setFlagEdit(0);
    };

    const [anchorEl, setAnchorEl] = useState(null);
    const [elemIndex, setElemIndex] = useState('')
    const [elemToDelete, setElemToDelete] = useState('')

    const handlePopper = (event, nElem, elem) => {
        if (flagEdit === 1) {
            setFlagEdit(0)
        }
        setElemIndex(nElem)
        setElemToDelete(elem)
        setAnchorEl(anchorEl ? null : event.currentTarget);
    };

    const [ outsideOpen, setOutsideOpen ] = useState(false)

    const handleOutside = () => {
        setOutsideOpen(!outsideOpen)
    }

    const confirmDeleteSpecialty = (event) => {
        event.preventDefault()
        setOutsideOpen(false)
        let data = {
            spe: [],
            sub: [],
            extra: [],
        }

        // Valida que especialidad eliminar
        let filteredSpecialtyData = elements.filter(elem => {
            return elem !== elemToDelete
        })
        data['spe'] = filteredSpecialtyData

        // Valida que subespecialidades eliminar
        let filteredSubSpecialityData = []
        if (subSpecialities && subSpecialities.length) {
            filteredSubSpecialityData = subSpecialities.filter(el => {
                const oldSubs = filterSubSpecialties(elemToDelete)
                return !oldSubs.includes(el)
            });
        }
        data['sub'] = filteredSubSpecialityData

        // Valida que extrasubespecialidades eliminar
        let filteredExtraSubSpecialtyData = extraSubSpecialities && extraSubSpecialities.length ? extraSubSpecialities : []
        let index = -1
        if (extraSubSpecialities && extraSubSpecialities.length) {
            index = extraSubSpecialities.findIndex((elem) => {
            const specialty = Object.keys(elem)
                return specialty[0] === elemToDelete
            })
        }
        if (index >= 0) {
            filteredExtraSubSpecialtyData[index][`${elemToDelete}`] = []
        }
        data['extra'] = filteredExtraSubSpecialtyData

        let boolValues = false
        if (data.spe && data.spe.length && data.spe.length !== 0) {
            boolValues = true
        }

        deleteSpecialty(uid, data, boolValues).then(res => {
            handleSnack()
        });
        setAnchorEl(null)
        handleSnack()
        setElemIndex('')
    };

    useEffect(() => {
        if (handleEditFlag) {
            handleEditFlag(flagEdit)
        }
    }, [flagEdit, handleEditFlag])

    const openPopper = Boolean(anchorEl);
    const classes = useStyles()
    
  return (
    <>
        {preview || fromPublic ?
            <SpecialtyPanel
                elements={preview ? elements : fromPublic}
                expanded={previewExpanded}
            /> :
            <>
                {elemIndex !== undefined && outsideOpen ?
                    <Popup
                        open={outsideOpen}
                        handleClose={handleOutside}
                        title='Seguro que deseas eliminar el área de práctica'
                        subtitle='Estás por eliminar una de tus áreas de práctica, recuerda que es importante mencionarlas para alcanzar una mayor audiencia de posibles clientes.'
                        primaryButton={true}
                        primaryButtonVariant='primarySolidOutlined'
                        primaryButtonText='Sí, eliminar'
                        primaryFunction={confirmDeleteSpecialty}
                        secondaryButton={true}
                        secondaryOptionalFunctionForCancel={() => setAnchorEl(null)}
                        secondaryButtonVariant='primary'
                    /> : null
                }
                <Popover
                    open={openPopper}
                    anchorEl={anchorEl}
                    className={classes.popper}
                    onClose={() => setAnchorEl(null)}
                    anchorOrigin={{
                        vertical: 'center',
                        horizontal: 'right',
                    }}
                >
                    <List className={classes.list} component="nav" aria-label="secondary mailbox folders">
                        <ListItem
                            className={classes.listItem}
                            button
                        >
                        <ListItemText onClick={FnEditSpecialty} className={classes.listItemText} primary="Editar" />
                        </ListItem>

                        <ListItem
                            className={classes.listItem}
                            button
                        >
                        <ListItemText onClick={handleOutside} className={classes.listItemText} primary="Eliminar" />
                        </ListItem>
                    </List>                
                </Popover>

                <div style={{ width: '100%' }}>
                    {elements && elements.map((elem, index) => {
                        if (index > 2 && !seeMore) {
                            return null
                        } else {
                            if (index === elemIndex && flagEdit === 1) {
                                return (
                                    <EditSpecialty
                                        elements={elements}
                                        outsideOpen={outsideOpen}
                                        handleOutside={handleOutside}
                                        evento={changeStatus}
                                        flagEdit={flagEdit}
                                        setFlagEdit={setFlagEdit}
                                        allSpecialties={allSpecialties}
                                        handleSnack={handleSnack}
                                        alreadyRewarded={alreadyRewarded}
                                        handleRewarded={handleRewarded}
                                        handleTrophieModalOpen={handleTrophieModalOpen}
                                        item={elemIndex}
                                        helper={helper}
                                        helperTrue={helperTrue}
                                        helperFalse={helperFalse}
                                        getValues={getValues}
                                        specialtyToEdit={elem}
                                    />
                                )
                            }
                            return (
                                <div className="specialtyAdded">
                                    <div className="specialtyAdded_limit">
                                        <ul className="specialtyAdded_container">
                                            <li className="specialtyAdded_container_list">
                                                <div className="specialtyAdded_container_info">
                                                    {elem ?
                                                        <p className="specialtyAdded_paragraph1">{elem}</p> :
                                                        null
                                                    }
                                                    {filteredSubSpecialities(elem, subSpecialities) &&
                                                    filteredSubSpecialities(elem, subSpecialities).length !== 0 ?
                                                    (filteredSubSpecialities(elem, subSpecialities).map((elem, index) => {
                                                        return (
                                                            <p className="specialtyAdded_paragraph2">- {elem}</p>
                                                        )
                                                    })) : null
                                                    }
                                                    {filterExtraSubs(elem, extraSubSpecialities) &&
                                                    filterExtraSubs(elem, extraSubSpecialities).length !== 0 ?
                                                    (filterExtraSubs(elem, extraSubSpecialities).map((elem, index) => {
                                                        return (
                                                            <p className="specialtyAdded_paragraph2">- {elem}</p>
                                                        )
                                                    })) : null
                                                    }
                                                </div>
                                            </li>
                                        </ul>
                                        <img
                                            src="/img/expand/menu-options.svg"
                                            alt="specialty"
                                            className="specialtyAdded_optionsImg"
                                            onClick={(event) => handlePopper(event, index, elem)}
                                        />
                                    </div>
                                </div>
                            )
                        }
                    })}
                    {elements && elements.length && elements.length > 3 && flagEdit === 0 ?
                        <div onClick={handleSeeMore} className={classes.contentSeeMoreBlock}>
                            <div className={classes.contentSeeMore}>
                                <p className={classes.seeMoreText}>
                                    {!seeMore ? 'Ver más' : 'Ver menos'}
                                </p>
                                <img src={!seeMore ? dropDown : dropUp} alt="drop" />
                            </div>
                        </div> : null
                    }
                </div>
            </>
        }
    </>
  );
}

const mapDispatchToProps = dispatch => ({
  deleteSpecialty: (uid, data, boolValues) =>
    dispatch(deleteSpecialty(uid, data, boolValues)),
})

const mapStateToProps = state => ({
  uid: state.authClient.uid,
  elements: state.authClient.specialties,
  subSpecialities: state.authClient.subSpecialities,
  extraSubSpecialities: state.authClient.extraSubSpecialities,
})

export default connect(mapStateToProps, mapDispatchToProps)(SpecialtyAdded);